// This an optional middleware for redux to check auth before performing certain actions.
// If the current action has { meta: { checkAuth: true } } we do this, otherwise skip
import actionCreators from './actionCreators';
import { checkAuthState } from '@nhl/auth-state-checker';

const checkAuth = store => next => async action => {
    if (action.meta && action.meta.checkAuth) {
        const isLoggedIn = await checkAuthState();
        if (isLoggedIn) {
            return next(action);
        } else {
            return next(actionCreators.logout());
        }
    } else {
        return next(action);
    }
};

export default checkAuth;